import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {Helmet} from "react-helmet";
import {withRouter} from 'react-router-dom';

/* Components */
import {FontTitle30} from '../../common/components/fonts';
import {colors} from '../../common/components/colors';
import {images} from '../../common/components/images';
import {LogoLoading} from "../../common/components/loading";

/* Containers */
import ProgramsFlow from './containers/flow';

const LoadingCenter = styled.div`
    margin: 60px auto;
    text-align: center;
`;

const MessageCenter = styled.div`
    margin: 140px auto;
    text-align: center;
`;

const Background = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: ${colors.background100};
`;

class IFramePrograms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {"isLoading": true, "programFound": false, "programId": null}
    }

    componentDidMount() {
        return this.init();
    }

    init = async () => {
        let path = window.location.pathname;
        let pathAdj = path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
        let pathSplit = pathAdj.split("/");
        if (pathSplit.length === 3) {
            return this.setState({"programFound": true, "programId": null, "isLoading": false});
        } else if (pathSplit.length === 4) {
            return this.setState({"programFound": true, "programId": pathSplit[pathSplit.length - 1], "isLoading": false});
        } else if (pathSplit.length === 5) {
            await this.props.history.push("/public/programs/"+pathSplit[pathSplit.length - 2]);
            return this.setState({"programFound": true, "programId": pathSplit[pathSplit.length - 2], "isLoading": false});
        } else {
            this.props.history.push("/public/programs");
            return this.setState({"programFound": true, "programId": null, "isLoading": false});
        }
    };

    render() {
        if(this.state.isLoading) {
            return(<Background><LoadingCenter><LogoLoading /></LoadingCenter></Background>)
        } else {
            if(this.state.programFound) {
                return(
                    <>
                        <Helmet>
                            <link rel={"icon"} type={"image/png"} href={images.favicon16px} sizes={"16x16"} />
                            <meta charSet={"utf-8"} />
                            <title>Willow</title>
                            <meta property={"og:type"} content={"website"} />
                            <meta property={"og:url"} content={window.location.href} />
                            <meta property={"og:site_name"} content={"Willow"} />
                        </Helmet>
                        <ProgramsFlow
                            entryPoint={"page"}
                            programId={this.state.programId}
                            urlList={"/public/programs"}
                            urlRequest={"/public/programs/request"}
                            urlDetails={"/public/programs/"+this.state.programId+"/details"}
                            urlCheckout={"/public/programs/"+this.state.programId+"/checkout"}
                            urlRegistrationComplete={"/public/programs/"+this.state.programId+"/registration-completed"}
                            urlRegistrationCompleteClose={"/public/programs"}
                            onSuccessClose={() => {this.props.history.push('/verify')}}
                        />
                    </>
                )
            } else {
                return(<Background><MessageCenter><FontTitle30>No program found</FontTitle30></MessageCenter></Background>)
            }
        }
    }

}

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IFramePrograms));